<template>
    <div style="text-align: center;">
        <div class="title">
          <div :class="{ hovers: clickclassif == 1 }" @click="clickclassfun('1','Personalforget')">通过账号和手机验证找回密码</div>
          <div :class="{ hovers: clickclassif == 2 }" @click="clickclassfun('2','Enterpriseforget')">找回账号</div>
        </div>
        <component :is="componentName"></component>
    </div>
</template>

<script>
import Enterpriseforget from './Enterprise_forget'
import Personalforget from './Personal_forget'
export default {
  data () {
    return {
      clickclassif: 1,
      componentName: 'Personalforget'
    }
  },
  components: {
    Personalforget,
    Enterpriseforget
  },
  methods: {
    clickclassfun (k, v) {
      this.clickclassif = k
      this.componentName = v
    }
  }
}
</script>

<style lang="scss" scoped>
  .title {
    font-size: 22px;
    color: black;
    margin-top: 50px;
    text-align: center;
    display: flex;
    justify-content: center;
    border-bottom:1px solid #d43c33;
    height: 55px;
    div{
      width: 340px;
      margin-left:100px;
      line-height: 55px;
    }
    .hovers{
      color: #fff;
      background: #d43c33;
    }
  }
</style>
